export default "__VITE_ASSET__72a54f7b__"